module.exports = __webpack_public_path__ + "static/media/EastHampton_19.7ee00be9.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/EastHampton_19.JPG
// module id = 238
// module chunks = 0